module.exports = __webpack_public_path__ + "img/BG.af1a6bca.png";